import React, { useContext, useEffect, useRef, useState } from "react";
import threeDots from "../../assets/images/dots-vertical.svg";
import { Space, Table } from "antd";
import _ from "lodash";

import {
  PostCallWithErrorResponse,
  simpleGetCall,
  simpleGetCallWithErrorResponse,
} from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";

import {
  div,
  Button,
  Form,
  option,
  FormControl,
  FormGroup,
  Badge,
} from "react-bootstrap";
import { AppContext } from "../../context/AppContext";
import Select from 'react-select';
import { ToastMsg } from "../TostMsg";

const GroupList = (props) => {
  // const [hide, setHide] = useState(false);

  const { codeRespondendHandler, clearCode } = props;

  const [valiteded, setValiteded] = useState(false);

  const [checkStrictly, setCheckStrictly] = useState(false);

  const [isActive, setIsActive] = useState(true);
  const [isActivewin, setIsActivewin] = useState(false);

  const profilePer = {
    codeId: 0,
    id: 0,
    pioneer: "",
    influencer: "",
    teamPlayer: "",
    logicalThinker: "",
    persuader: "",
    achiever: "",
    perfectionist: "",
    collaborator: "",
    assessor: "",
    implementor: "",
    motivator: "",
    leader: "",
    administrator: "",
    mediator: "",
    allRounder: "",
  };

  const initialState = {
    id: 0,
    accessCode: "",
    reason: "",
    company: "",
    designation: "",
    additionalQs1: "no",
    additionalQs2: "no",
    questionOne: "",
    questionTwo: "",
    questionThree: "",
    address: "",
    linktoAssess: "",
    idealExp: [],
    eduLevel: [],
    eduArea: [],
    industry: [],
    salaryRange: "",
    startDate: "",
    primaryMatch: "",
    secoundryMatch: "",
    primaryProfile: "",
    secoundryProfile: "",
    association: "",
    isActive: true,
    from: "",
    isNormalAssesment: true,
  };

  const [details, setDetails] = useState(initialState);

  const { adminData } = useContext(AppContext);

  const [initialProfiles, setInitialProfiles] = useState(profilePer);

  const [isEdit, setIsEdit] = useState(false);

  const [show, setShow] = useState(false);
  const [reqfield, setReqfield] = useState(null);
  const handleClose = () => {
    setShowModal(false);
    setDetails(initialState);

    setEnterEmail("");

    setShowEmails([]);

    setIsEdit(false);

    setValiteded(false);

    setInitialProfiles(profilePer);

    setShow(false);
  };
  const handleShow = () => setShow(true);

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      console.log("File selected:", file.name);
      // You can add further logic to handle the file upload here
    }
  };

  const [groupListData, setGroupListData] = useState([]);

  const [isLoadin, setIsLoading] = useState(true);

  const [rowsToShow, setRowsToShow] = useState(10);

  const handleRowsToShowChange = (event) => {
    setRowsToShow(Number(event.target.value));
  };

  const getData = () => {
    const url = `${ApiConfig.GROUP_LIST}${localStorage.getItem("Username")
      }&IsActive=${isActive}`;
    simpleGetCallWithErrorResponse(url)
      .then((res) => {
        console.log(res);

        if (res?.json?.succeded) {
          setGroupListData(res?.json?.response);
          console.log(res?.json?.data?.length);
        } else {
          console.log("something went wrong");
        }

        setIsLoading(false);
      })
      .catch((err) => {
        console.log("something went wrong");

        setIsLoading(false);
      });
  };

  useEffect(() => {
    //codeRespondendHandler('')
    clearCode();
    getData();
  }, [isActive]);

  const copyCode = (code, masterId, domainName) => {
    navigator.clipboard.writeText(
      `https://${domainName}.wifiattendance.com/lywo?code=${code}&ClientMasterId=${masterId}`
    );
  };

  const [error, setError] = useState("");
  const [errorAdd, setErrorAdd] = useState("");

  // const handleSubmit = (event) => {
  //   console.log(details);

  //   event.preventDefault();
  //   event.stopPropagation();
  //   const form = event.currentTarget;
  //   if (form.checkValidity() == false) {
  //     console.log(form.checkValidity());

  //     setValiteded(true);
  //   }

  //   else {
  //     if (details.accessCode.length != 7) {
  //       toastMsg("error", "please Enter 7 Digit Valid Access Code");
  //       return;
  //     }

  //     if (showEmails.length == 0 && details.reason === "Job Application") {
  //       toastMsg("error", "Please Add Users");
  //       return;
  //     }

  //     PostCallWithErrorResponse(ApiConfig?.ADD_JOB, {
  //       id: details?.id,
  //       isActive: details?.isActive,
  //       code: details?.accessCode,
  //       codeAssociation: details?.association,
  //       position: details?.designation,
  //       reason: details?.reason,
  //       company: details?.company,
  //       additionalPart1: details.additionalQs1,
  //       additionalPart2: details.additionalQs2,
  //       primaryId: details?.primaryProfile,
  //       secondaryId: details?.secoundryProfile,
  //       primaryMatch: details?.primaryMatch,
  //       secondaryMatch: details.secoundryMatch,
  //       profilePer: details.reason === "Job Application" ? initialProfiles : {},
  //       users: showEmails,

  //       additionalPart3: details?.additionalQs3,
  //       addressOfSheet: details?.address,
  //       linkToAssessment: details?.linktoAssess,
  //       idealExperience: details?.idealExp,
  //       idealEducationLevel: details?.eduLevel,
  //       idealEducationArea: details?.eduArea,
  //       idealIndustry: details?.industry,
  //       idealSalaryRange: details?.salaryRange,
  //       idealStartDate: details?.startDate,
  //     })
  //       .then((res) => {
  //         console.log(res);

  //         if (res?.json?.succeded) {
  //           setIsEdit(false);
  //           toastMsg("success", res?.json?.response?.statusMessage);
  //           getData();
  //           handleClose();
  //         } else {
  //           toastMsg("error", res?.json?.response?.statusMessage);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log("something wrong");
  //       });
  //   }
  // };

  // const handleSubmit = (event) => {
  //   event.preventDefault();
  //   event.stopPropagation();

  //   const form = event.currentTarget;
  //   if (!form.checkValidity()) {
  //     console.log(form.checkValidity());
  //     setValiteded(true);
  //     return;
  //   }

  //   if (!details) {
  //     console.error("Details are not defined");
  //     return;
  //   }

  //   const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
  //   if (!urlPattern.test(details.linktoAssess)) {
  //     setError("Please enter a valid hyperlink (e.g., https://example.com)");
  //     return;
  //   } else {
  //     setError("");
  //   }

  //   if (details.accessCode.length !== 7) {
  //     toastMsg("error", "Please enter a 7-digit valid access code");
  //     return;
  //   }

  //   if (showEmails.length === 0 && details.reason === "Job Application") {
  //     toastMsg("error", "Please add users");
  //     return;
  //   }

  //   const payload = {
  //     id: details.id,
  //     isActive: details.isActive,
  //     code: details.accessCode,
  //     codeAssociation: details.association,
  //     position: details.designation,
  //     reason: details.reason,
  //     company: details.company,
  //     additionalPart1: details.additionalQs1,
  //     additionalPart2: details.additionalQs2,
  //     primaryId: details.primaryProfile,
  //     secondaryId: details.secoundryProfile,
  //     primaryMatch: details.primaryMatch,
  //     secondaryMatch: details.secoundryMatch,
  //     profilePer: details.reason === "Job Application" ? initialProfiles : {},
  //     users: showEmails,
  //     additionalPart3: details.additionalQs3,
  //     addressOfSheet: details.address,
  //     linkToAssessment: details.linktoAssess,
  //     idealExperience: details.idealExp,
  //     idealEducationLevel: details.eduLevel,
  //     idealEducationArea: details.eduArea,
  //     idealIndustry: details.industry,
  //     idealSalaryRange: details.salaryRange,
  //     idealStartDate: details.startDate,
  //   };

  //   // Proceed with API call only if all validations pass
  //   PostCallWithErrorResponse(ApiConfig?.ADD_JOB, payload)
  //     .then((res) => {
  //       if (res?.json?.succeded) {
  //         setIsEdit(false);
  //         toastMsg("success", res?.json?.response?.statusMessage);
  //         getData();
  //         handleClose();
  //       } else {
  //         toastMsg("error", res?.json?.response?.statusMessage);
  //       }
  //     })
  //     .catch((err) => {
  //       console.error("Something went wrong:", err);
  //     });
  // };

  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget;
    if (!form.checkValidity()) {
      console.log(form.checkValidity());
      setValiteded(true);
      return;
    }

    if (!details) {
      console.error("Details are not defined");
      return;
    }

    const urlRegex = /^(https?:\/\/[^\s$.?#].[^\s]*)$/;
    const googleDocsRegex = /https?:\/\/docs\.google\.com\//;


    if (details.address && !googleDocsRegex.test(details.address)) {
      ToastMsg(
        "error",
        "Please enter a valid Google Document link for 'Address of the Sheet"
      );
      return;
    }

    if (details.linktoAssess && !urlRegex.test(details.linktoAssess)) {
      ToastMsg(
        "error",
        "Please enter a valid hyperlink for 'Link to Assessment'"
      );
      return;
    }

    if (details.accessCode.length !== 7) {
      ToastMsg("error", "Please enter a 7-digit valid access code");
      return;
    }

    if (showEmails.length === 0 && details.reason === "Job Application") {
      ToastMsg("error", "Please add users");
      return;
    }

    const payload = {
      id: details.id,
      isActive: details.isActive,
      code: details.accessCode,
      codeAssociation: details.association,
      position: details.designation,
      reason: details.reason,
      company: details.company,
      additionalPart1: details.additionalQs1,
      additionalPart2: details.additionalQs2,
      primaryId: details.primaryProfile ? details.primaryProfile : 0,
      secondaryId: details.secoundryProfile || 0,
      primaryMatch: details.primaryMatch,
      secondaryMatch: details.secoundryMatch,
      profilePer: details.reason === "Job Application" ? initialProfiles : {},
      users: showEmails,
      question1: details.questionOne,
      question2: details.questionTwo,
      question3: details.questionThree,
      addressOfSheet: details.address,
      fromEmail: details.from,
      linkToAssessment: details.linktoAssess,
      idealExperience: details.idealExp,
      idealEducationLevel: details.eduLevel,
      idealEducationArea: details.eduArea,
      idealIndustry: details.industry,
      idealSalaryRange: details.salaryRange || [],
      idealStartDate: details.startDate ? details.startDate : new Date(),
      isNormalAssesment: details.isNormalAssesment
    };

    PostCallWithErrorResponse(ApiConfig?.ADD_JOB, JSON.stringify(payload))
      .then((res) => {
        if (res?.json?.succeded) {
          setIsEdit(false);
          ToastMsg("success", res?.json?.response?.statusMessage);
          getData();
          handleClose();
        } else {
          ToastMsg("error", res?.json?.response?.statusMessage);
        }
      })
      .catch((err) => {
        console.error("Something went wrong:", err);
      });
  };

  const paginationConfig = {
    pageSizeOptions: [
      "10",
      "20",
      "30",
      "40",
      "50",
      "60",
      "70",
      "80",
      "90",
      "100",
    ], // Options for items per page
    defaultPageSize: 50, // Default number of items per page
    showSizeChanger: false, // Show the dropdown to change page size
    onChange: (page, pageSize) => {
      console.log("Page:", page, "PageSize:", pageSize);
    },
  };

  const handleChage = (key, val) => {
    if (key === "reason") {
      let prt1 = "";
      let part2 = "";

      if (
        val === "Individual User" ||
        val === "Investor" ||
        val === "Investor as Individual User"
      ) {
        prt1 = "no";
        part2 = "no";
      }

      if (val === "Job Application") {
        prt1 = "yes";
        part2 = "no";
      }

      if (val === "Internal Assessment") {
        prt1 = "no";
        part2 = "yes";
      }

      setDetails((prev) => ({
        ...prev,
        reason: val,
        additionalQs1: prt1,
        additionalQs2: part2,
      }));
      const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
      if (!urlPattern.test(details.linktoAssess)) {
        setError("Please enter a valid hyperlink (e.g., https://example.com)");
      } else {
        setError("");
      }

      return;
    }

    setDetails((prev) => ({
      ...prev,
      [key]: val,
    }));
  };
  // const [enterEmail, setEnterEmail] = useState("");
  // const [showEmails, setShowEmails] = useState([]);
  // const [showed, setShowed] = useState(false);

  // const handleAddEmail = () => {
  //   setShowEmails([...showEmails, enterEmail]);
  //   setShowed(true);
  //   setEnterEmail("");
  // };
  const [enterEmail, setEnterEmail] = useState("");
  const [showEmails, setShowEmails] = useState([]);
  const [showed, setShowed] = useState(false);

  const handleAddEmail = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (enterEmail.trim() !== "") {
      if (!emailRegex.test(enterEmail)) {
        ToastMsg("error", "Please Enter Valid User Email");
        return;
      }

      let index = showEmails.findIndex((i) => i.email === enterEmail);

      if (index != -1) {
        ToastMsg("error", "Email Already Added");
        return;
      }

      setShowEmails([
        ...showEmails,
        {
          codeId: 0,
          email: enterEmail,
        },
      ]);
      setShow(true);
      setEnterEmail("");
    }
  };

  const removeEmail = (indexToRemove) => {
    const updatedEmails = showEmails.filter(
      (_, index) => index !== indexToRemove
    );
    setShowEmails(updatedEmails);
  };

  const handleProfiles = (key, val) => {
    setInitialProfiles((prev) => ({
      ...prev,
      [key]: val,
    }));
  };

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));
  const [filteredInfo, setFilteredInfo] = useState({});
  const [sortedInfo, setSortedInfo] = useState({});

  const handleChange = (pagination, filters, sorter) => {
    console.log("Various parameters", pagination, filters, sorter);
    setFilteredInfo(filters);
    setSortedInfo(sorter);
  };
  const columns = [
    {
      title: "Access Code",
      render: (record) => <h5 className="my-auto">{record}</h5>,
      dataIndex: "code",
      sorter: (a, b) => a.code.localeCompare(b.code),
      filters: _.uniqWith(
        filterData(groupListData)((i) => i.code),
        _.isEqual
      ),
      filteredValue: filteredInfo.code || null,
      filterSearch: true,
      onFilter: (value, record) =>
        record.code.toString().toLowerCase().includes(value.toLowerCase()),
      onCell: (record, rowIndex) => {
        return {
          onClick: (env) => {
            codeRespondendHandler(
              record?.code,
              record?.company,
              record?.designation,
              record?.reason
            );
          },
        };
      },
    },

    {
      title: "Form Type",
      dataIndex: "reason",
      sorter: (a, b) => a.reason?.localeCompare(b.reason),
      filters: _.uniqWith(
        filterData(groupListData)((i) => i.reason),
        _.isEqual
      ),
      filteredValue: filteredInfo.reason || null,
      filterSearch: true,
      onFilter: (value, record) =>
        record.reason.toString().toLowerCase().includes(value.toLowerCase()),
    },
    {
      title: "Company",
      dataIndex: "company",
      sorter: (a, b) => a.company?.localeCompare(b.company),
      filters: _.uniqWith(
        filterData(groupListData)((i) => i.company),
        _.isEqual
      ),
      filteredValue: filteredInfo.company || null,
      filterSearch: true,
      onFilter: (value, record) =>
        value === ""
          ? record.company.toString().toLowerCase() === value.toLowerCase()
          : record.company
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
    },
    {
      title: "Designation",
      dataIndex: "designation",
      sorter: (a, b) => a.designation.localeCompare(b.designation),
      filters: _.uniqWith(
        filterData(groupListData)((i) => i.designation),
        _.isEqual
      ),
      filteredValue: filteredInfo.designation || null,
      filterSearch: true,
      onFilter: (value, record) =>
        value === ""
          ? record.designation.toString().toLowerCase() === value.toLowerCase()
          : record.designation
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase()),
    },
    // {
    //   title: "Add'l Qs Part 1",
    //   dataIndex: "additionalPart1",
    //   sorter: (a, b) => a.additionalpart1 - b.additionalpart1,
    //   filters: _.uniqWith(
    //     filterData(groupListData)((i) => i.additionalPart1),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.additionalPart1 || null,
    //   filterSearch: true,
    //   onFilter: (value, record) =>
    //     record.additionalPart1 ? record.additionalPart1.includes(value) : false,
    // },
    // {
    //   title: "Add'l Qs Part 2",
    //   dataIndex: "additionalPart2",
    //   sorter: (a, b) =>
    //     new Date(a.additionalpart2) - new Date(b.additionalPart2),
    //   filters: _.uniqWith(
    //     filterData(groupListData)((i) => i.additionalPart2),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.additionalPart2 || null,
    //   filterSearch: true,
    //   onFilter: (value, record) =>
    //     record.additionalPart2 ? record.additionalPart2.includes(value) : false,
    // },
    // {
    //   title: "Applications",
    //   dataIndex: "completed",
    //   sorter: (a, b) => new Date(a.completed) - new Date(b.completed),
    //   filters: _.uniqWith(
    //     filterData(groupListData)((i) => i.completed),
    //     _.isEqual
    //   ),
    //   filteredValue: filteredInfo.completed  ,
    //   filterSearch: true,
    //   onFilter: (value, record) => record?.completed == value,
    // },
    {
      title: "Applications",
      dataIndex: ["completed", "respondent"],
      sorter: (a, b) => new Date(a.completed) - new Date(b.completed),

      // filters: _.uniqWith(
      //   filterData(groupListData)((i) => i.completed),
      //   _.isEqual
      // ).map((item) => ({ text: item, value: item })),
      filteredValue: filteredInfo?.completed,
      // filterSearch: false,
      // onFilter: (value, record) => {
      //   return record?.completed === value;
      // },
      render: (text, record) => {
        return `${record.completed} / ${record.respondent}`;
      },
    },
    {
      title: "Actions",
      render: (record) => (
        <div class="dropdown">
          <img
            src={threeDots}
            alt=""
            type="button"
            id="dropdownMenuButton"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"

          />
          <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
            <li
              class="dropdown-item"
              style={{ cursor: "pointer" }}
              onClick={() => copyCode(record?.code, record?.clientMasterId, record?.domainName)}
            >
              Copy Link
            </li>
            <li
              class="dropdown-item"
              style={{ cursor: "pointer" }}
              onClick={() =>
                codeRespondendHandler(
                  record?.code,
                  record?.company,
                  record?.designation,
                  record?.reason
                )
              }
            >
              View Respondents
            </li>
            {localStorage.getItem("admin") &&
              JSON.parse(localStorage.getItem("admin")) == "Admin" && (
                <li
                  class="dropdown-item"
                  style={{ cursor: "pointer" }}
                  onClick={() => getEditData(record.code)}
                >
                  Edit
                </li>
              )}
          </div>
        </div>
      ),
    },
  ];
  const [checked, setChecked] = useState(true);
  const handleClickcheck = () => {
    setChecked(!checked);
  };

  const toggleSwitch = () => {
    setIsActive(!isActive);
  };
  const toggleSwitchWindow = () => {
    setIsActivewin(!isActivewin);
  };

  const getEditData = (code) => {
    setIsEdit(true);



    simpleGetCallWithErrorResponse(ApiConfig.GET_CODE_DETAILS + code).then(
      (res) => {
        console.log(res);

        if (res?.json?.succeded) {
          const responseData = res?.json?.response;
          setSelectedIndustry(transformIndustryToOptions(responseData?.idealIndustry));
          setSelectedOptions(transformEduLevelToOptions(responseData?.idealEducationLevel));
          setSelectedArea(transformEduAreaToOptions(responseData?.idealEducationArea));
          setSelectedSalary(transformSalaryToOptions(responseData?.idealSalaryRange));
          setSelectedExp(transformExpToOptions(responseData?.idealExperience));


          // Set ideal experience
          setIdealExp(responseData?.idealExperience || []);
          setInputValue("");

          setDetails({
            industry: responseData?.idealIndustry,
          });
          setDetails({
            isActive: res?.json?.response?.isActive,
            id: res?.json?.response?.id,
            accessCode: code,
            reason: res?.json?.response?.reason,
            company: res?.json?.response?.company,
            designation: res?.json?.response?.position,
            additionalQs1: res?.json?.response?.additionalPart1,
            additionalQs2: res?.json?.response?.primaryMatch,
            primaryMatch: res?.json?.response?.primaryMatch,
            secoundryMatch: res?.json?.response?.secondaryMatch,
            primaryProfile: res?.json?.response?.primaryId,
            secoundryProfile: res?.json?.response?.secondaryId,
            association: res?.json?.response?.codeAssociation,

            questionOne: res?.json?.response?.question1,
            questionTwo: res?.json?.response?.question2,
            questionThree: res?.json?.response?.question3,
            isNormalAssesment: res?.json?.response?.isNormalAssesment,

            address: res?.json?.response?.addressOfSheet,
            linktoAssess: res?.json?.response?.linkToAssessment,
            from: res?.json?.response?.fromEmail,
            idealExp: res?.json?.response?.idealExperience,
            eduLevel: res?.json?.response?.idealEducationLevel,
            eduArea: res?.json?.response?.idealEducationArea,
            industry: res?.json?.response?.idealIndustry,
            salaryRange: res?.json?.response?.idealSalaryRange,
            startDate: res?.json?.response?.reason === "Job Application"
              ? (res?.json?.response?.idealStartDate
                ? res?.json?.response?.idealStartDate.split("T")[0].split("-").join("-")
                : null)
              : null,
          });
          handleShowAddGrp();
          // handleShow();

          if (res?.json?.response?.reason === "Job Application") {
            setShowEmails(res?.json?.response?.users);

            if (res?.json?.response?.profilePer) {
              setInitialProfiles(res?.json?.response?.profilePer);
            }
          }
        } else {
          ToastMsg("error", res?.json?.message);
        }
      }
    );
  };

  const [showAddGrp, setShowAddGrp] = useState(null);
  const [showModal, setShowModal] = useState(null);

  const handleShowAddGrp = () => {

    // setHide(true);
    setShowModal(true);
    handleShow();
    // setShowAddGrp(true);
  };

  const [areaList, setAreaList] = useState([]);

  useEffect(() => {
    getAllspecialization();
    getAllIndustryList();
    getEmailList();
  }, []);

  const [industryList, setIndustryList] = useState([]);
  const getAllIndustryList = () => {
    simpleGetCall(ApiConfig.GET_INDUSTRY_LIST)
      .then((res) => {
        if (res.succeded) {
          setIndustryList(res?.response);
        } else {
          setIndustryList([]);
        }
      })
      .catch((err) => console.log(err));
  };
  const getAllspecialization = () => {
    simpleGetCall(ApiConfig.GET_AREA_OF_EDUCATION)
      .then((res) => {
        if (res.succeded) {
          setAreaList(res.response);
          console.log(res.response);
        } else {
          setAreaList([]);
        }
      })
      .catch((err) => console.log(err));
  };

  // const [filteredGrpListData, setFilteredGrpListData] = useState([]);
  // const [filterVal, setFilterVal] = useState("");
  // const handleFilterVal = (e) => {
  //   const { value } = e.target;
  //   setFilterVal(value);
  //   setFilteredGrpListData(groupListData.filter(x => x.company.toLowerCase().includes(value) || x.designation.toLowerCase().includes(value)));
  // }

  const [emailList, setEmailList] = useState([]);
  const getEmailList = () => {
    simpleGetCallWithErrorResponse(ApiConfig.GET_AUTHENTICATED_SENDERS)
      .then((res) => {
        console.log(res.json);

        setEmailList(res.json);
      })
      .catch((err) => console.log(err));
  };

  const expOptions = [
    { value: "1-3", label: "1 to 3 Yrs" },
    { value: "3-5", label: "3 to 5 Yrs" },
    { value: "5-7", label: "5 to 7 Yrs" },
    { value: "7-9", label: "7 to 9 Yrs" },
    { value: "9-12", label: "9 to 12 Yrs" },
    { value: "12-15", label: "12 to 15 Yrs" },
    { value: "15-20", label: "15 to 20 Yrs" },
    { value: "20-25", label: "20 to 25 Yrs" },
    { value: "25-30", label: "25 to 30 Yrs" },
    { value: "30+", label: "Above 30 Yrs" },
  ]
  const [selectedExp, setSelectedExp] = useState([]);
  const handleExpChange = (selected) => {
    setSelectedExp(selected || []);
    setDetails({ ...details, idealExp: selected ? [selected.value] : [] });
    console.log(details);
  }

  const options = [
    { value: 'High School', label: 'High School' },
    { value: 'Diploma', label: 'Diploma' },
    { value: 'PG Diploma', label: 'PG Diploma' },
    { value: "Bachelor's", label: "Bachelor's" },
    { value: "Master's", label: "Master's" },
    { value: 'PhD', label: 'PhD' },
  ];

  const [selectedOptions, setSelectedOptions] = useState([]);
  const handleChangemulti = (selected) => {
    setSelectedOptions(selected || []);

    const selectedValues = (selected || []).map(option => option.value);
    setDetails({ ...details, eduLevel: selectedValues });
    console.log(details);
  };

  const [selectedArea, setSelectedArea] = useState([]);
  const optionsArealist = areaList.map(x => ({
    value: x.specializationName,
    label: x.specializationName
  }
  ))
  const handleMultiArea = (selected) => {
    setSelectedArea(selected || []);
    const selectedValues = (selected || []).map(option => option.value);
    setDetails({ ...details, eduArea: selectedValues });
    console.log(details);
  }
  const [selectedIndustry, setSelectedIndustry] = useState([]);
  const optionsIndustry = industryList.map(x => ({
    value: x.label,
    label: x.label
  }
  ))
  const transformIndustryToOptions = (industries) => {
    if (!industries) return [];
    return industries.map(industry => ({
      value: industry,
      label: industry
    }));
  };


  const transformEduLevelToOptions = (eduLevels) => {
    if (!eduLevels) return [];
    return eduLevels.map(level => ({
      value: level,
      label: level
    }));
  };

  const transformEduAreaToOptions = (eduAreas) => {
    if (!eduAreas) return [];
    return eduAreas.map(area => ({
      value: area,
      label: area
    }));
  };

  const transformSalaryToOptions = (salaryRanges) => {
    if (!salaryRanges) return [];
    return salaryRanges.map(range => ({
      value: range,
      label: range
    }));
  };
  const transformExpToOptions = (experiences) => {
    if (!experiences) return [];
    return experiences.map(exp => ({
      value: exp,
      label: exp.replace('-', ' to ') + ' Yrs'
    }));
  };


  const handleMultiIndustry = (selected) => {
    setSelectedIndustry(selected || []);
    const selectedValues = (selected || []).map(option => option.value);
    setDetails({ ...details, industry: selectedValues });
    console.log(details);
  }

  const [selectedSalary, setSelectedSalary] = useState([]);
  const optionsSalary = [
    { value: 'Below 3 Lakhs per year  ', label: 'Below 3 Lakhs per year' },
    { value: '3-6 Lakhs per year', label: '3-6 Lakhs per year' },
    { value: '6-10 Lakhs per year', label: '6-10 Lakhs per year' },
    { value: '10-15 Lakhs per year', label: '10-15 Lakhs per year' },
    { value: '15-20 Lakhs per year', label: '15-20 Lakhs per year' },
    { value: '20-25 Lakhs per year', label: '20-25 Lakhs per year' },
    { value: '25-30 Lakhs per year', label: '25-30 Lakhs per year' },
    { value: 'Above 30 Lakhs per year', label: 'Above 30 Lakhs per year' },
    { value: 'Above 50 Lakhs per year', label: 'Above 50 Lakhs per year' },
    { value: 'Above 1 Crore per year', label: 'Above 1 Crore per year' },
  ]
  const handleMultiSalary = (selected) => {
    setSelectedSalary(selected || []);
    const selectedValues = (selected || []).map(option => option.value);
    setDetails({ ...details, salaryRange: selectedValues });
    console.log(details);
  }

  const [inputValue, setInputValue] = useState("");
  const [idealExpp, setIdealExp] = useState([]);

  const handleKeyDown = (e) => {
    if (e.key === "Enter" || e.key === ",") {
      e.preventDefault();
      const exp = inputValue.trim();
      if (exp > 0 && !idealExpp.includes(exp)) {
        const newExp = [...idealExpp, exp];
        setIdealExp(newExp);
        setDetails(prev => ({ ...prev, idealExp: newExp }));
      }
      setInputValue("");
    }

    if (e.key === "Backspace" && inputValue.length === 0) {
      const newExp = idealExpp.slice(0, -1);
      setIdealExp(newExp);
      setDetails(prev => ({ ...prev, idealExp: newExp }));
    }
  };
  const removeExp = (exp) => {
    setIdealExp(idealExpp.filter((x) => x !== exp));
    setDetails({ ...details, idealExp: idealExpp });
    console.log(details);


  };

  return (
    <>
      {!showModal && (
        <>
          {" "}
          <div className="row justify-content-between mt-4">


            <div className="col-12 d-flex justify-content-end">
              {/* <div className="col-3 my-auto">
                <input
                  value={filterVal}
                  onChange={handleFilterVal}
                  type="text"
                  style={{height:"35px"}}
                  className="bg-white border search-input pe-2 rounded-2"
                />
              </div> */}
              <div className="col-3 my-auto">
                <div className="row align-items-center">
                  <div className="col-4 text-nowrap toggle-label text-end" style={{ fontSize: "12px" }}>
                    Inactive Only
                  </div>
                  <div
                    style={{ scale: "0.8" }}
                    onClick={toggleSwitch}
                    className={`col-2 toggle-switch ${isActive ? "active" : ""
                      }`}
                  >
                    <div className="toggle-circle"></div>
                  </div>
                  <div
                    className="col-1 text-nowrap toggle-label"
                    style={{ marginLeft: "-12px", fontSize: "12px" }}
                  >
                    Active Only
                  </div>
                </div>
              </div>
              <div className="col-2">

                <button
                  style={{ fontSize: "12px" }}
                  className="ml-4 btnVldt"
                  onClick={handleShowAddGrp}
                >
                  Add Group
                </button>

              </div>

            </div>
          </div>
          <div className="candListBox ">
            <div className="candListHdr">
              <div className="canLisTxtStyl">
                <p>Group List</p>
              </div>

              <div className="grouplist-table">
                <Table
                  size="large"
                  columns={columns}
                  className="grouplisttable-alljobs"
                  // dataSource={filteredGrpListData.length>0? filteredGrpListData : groupListData}
                  dataSource={groupListData}
                  onChange={handleChange}
                  pagination={paginationConfig}
                ></Table>
              </div>

              {/* <div className="canLisSearchArea">
          <div className="searchBox">
            <img src={SearchIcon} className="boxIcon" alt="Logo" />
            <Form.Control
              type="text"
              className="searchForm.Control"
              placeholder="Search"
              // readOnly
            />
          </div>
          <div className="canLisIconBox">
            <img src={filterLines} className="boxIcon" alt="Logo" />
          </div>
          <div className="canLisIconBox">
            <img src={downloadIcon} className="boxIcon" alt="Logo" />
          </div>
          <div className="canLisIconBox">
            <img src={trashIcon} className="boxIcon" alt="Logo" />
          </div>
          {/* <button className="uploadBtn" onClick={handleUploadClick}>
            <img src={plusIcon} className="boxIcon" alt="Logo" />
            <p>Upload</p>
            <Form.Control
              type="file"
              className="fileForm.Control"
              ref={fileForm.ControlRef}
              onChange={handleFileChange}
              style={{ display: "none" }}
              accept=".pdf,.doc,.docx"
            />
          </button> }
        </div> */}
            </div>
          </div>{" "}
        </>
      )}

      {showModal && (
        <div
          // show={show}
          // centered
          // onHide={handleClose}
          // dialogClassName="custom-modal"
          // size={`${details.reason === "Job Application" ? "xl" : "lg"}`}
          style={{
            backgroundColor: "white",
            height: "auto",
            marginTop: "14px",
            margin: "10px",
            padding: "19px",
            borderRadius: "10px",
          }}
        >
          <div>
            <div closeButton className="custom-close-btn">
              <div className="d-flex justify-content-between">
                <h5 className="custom-modal-title">Add/ Edit Group</h5>
                <button className="btn-close" onClick={handleClose}></button>
              </div>
              <hr />
            </div>
            <div>
              <Form noValidate validated={valiteded} onSubmit={handleSubmit}>
                <div className="row">
                  <div
                    className={`${details.reason === "Job Application" ? "col-6" : "col-12"
                      }`}
                  >
                    <div className="d-flex align-items-center">
                      <div className="col-6">
                        <Form.Group controlId="accessCode" className="mb-3">
                          <Form.Label>Access Code</Form.Label>
                          <Form.Control
                            disabled={isEdit}
                            type="text"
                            placeholder="Access Code"
                            id="accessCode"
                            value={details.accessCode}
                            minLength={7}
                            maxLength={7}
                            required
                            isInvalid={
                              valiteded && details.accessCode.length != 7
                            }
                            onChange={(e) =>
                              handleChage(
                                "accessCode",
                                e.target.value.toUpperCase()
                              )
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter 7 Digit Valid Code!
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>

                      <div className="col-auto ms-5 mt-3">
                        <div className="App-header">
                          <div
                            className="d-flex "
                            onClick={() => {
                              handleChage("isActive", !details?.isActive);
                            }}
                          >
                            <div className="col-3 me-3 text-nowrap toggle-label">
                              Inactive
                            </div>
                            <div style={{ scale: "0.8" }}
                              className={`col-6 toggle-switch  ${details?.isActive ? "active" : ""
                                }`}
                            >
                              <div className="toggle-circle"></div>
                            </div>
                            <div className="col-3 me-3 text-nowrap toggle-label">
                              Active
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <Form.Group controlId="reason" className="mb-3 col-md-6">
                        <Form.Label>Application Type </Form.Label>
                        <Form.Select
                          disabled={isEdit}
                          required
                          value={details?.reason}
                          onChange={(e) => {
                            setValiteded(false);
                            handleChage("reason", e.target.value);
                          }}
                        >
                          <option disabled value={""}>
                            Select reason
                          </option>
                          {/* <option value="Individual User">Individual User</option> */}
                          <option value="Job Application">Job Application</option>
                          <option value="Internal Assessment">
                            Internal Assessment
                          </option>
                          <option value="Investor As Individual User">
                            Investor As Individual User
                          </option>
                        </Form.Select>
                        <Form.Control.Feedback type="invalid">
                          Please Select Reason!
                        </Form.Control.Feedback>
                        {/* <Form.Control type="email" placeholder="Reason" /> */}
                      </Form.Group>
                      <div className="col-md-6 col-md-6">
                        <label>Assesment Type</label>
                        <div className="App-header mt-3 ">
                          <div
                            className="d-flex "
                            onClick={() => {
                              if (isEdit) return
                              handleChage("isNormalAssesment", !details?.isNormalAssesment);
                            }}
                          >
                            <div className=" me-3 text-nowrap toggle-label">
                              Short
                            </div>
                            <div style={{ scale: "0.8" }}
                              className={`col-6 toggle-switch  ${details?.isNormalAssesment ? "active" : ""
                                }`}
                            >
                              <div className="toggle-circle"></div>
                            </div>
                            <div className="col-3 me-3 text-nowrap toggle-label">
                              Normal
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {details?.reason !== "Individual User" &&
                      details?.reason !== "Investor" &&
                      details?.reason !== "" && (
                        <>
                          <Form.Group controlId="company" className="mb-3">
                            <Form.Label>Company</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Company"
                              required
                              value={details?.company}
                              onChange={(e) =>
                                handleChage("company", e.target.value)
                              }
                            />
                            <Form.Control.Feedback type="invalid">
                              Please Enter Company Name!
                            </Form.Control.Feedback>
                          </Form.Group>

                        </>
                      )}
                    {/*  */}
                    {details.reason === "Job Application" && (
                      <div className="mt-3">
                        <Form.Group controlId="designation" className="mb-3">
                          <Form.Label>Designation</Form.Label>
                          <Form.Control
                            type="text"
                            required
                            placeholder="Designation"
                            value={details?.designation}
                            onChange={(e) =>
                              handleChage("designation", e.target.value)
                            }
                          />
                          <Form.Control.Feedback type="invalid">
                            Please Enter Designation!
                          </Form.Control.Feedback>
                        </Form.Group>


                        {isEdit ? <></> : <>
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Custom Question 1 (Answer is Yes/No only)
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Custom Question 1"
                              value={details.questionOne}
                              // disabled={isEdit && hide}
                              onChange={(e) =>
                                handleChage("questionOne", e.target.value)
                              }
                            />
                            <Form.Text>
                              leave blank if you wish to not use
                            </Form.Text>
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Custom Question 2 (Answer is Yes/No only)
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Custom Question 2"
                              value={details.questionTwo}
                              // disabled={isEdit && hide}
                              onChange={(e) =>
                                handleChage("questionTwo", e.target.value)
                              }
                            />
                            <Form.Text>
                              leave blank if you wish to not use
                            </Form.Text>
                          </Form.Group>
                          <Form.Group className="mb-3">
                            <Form.Label>
                              Custom Question 3 (Answer is Yes/No only)
                            </Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Custom Question 3"
                              // disabled={isEdit && hide}
                              value={details.questionThree}
                              onChange={(e) =>
                                handleChage("questionThree", e.target.value)
                              }
                            />
                            <Form.Text>
                              leave blank if you wish to not use
                            </Form.Text>
                          </Form.Group>
                        </>}


                        <Form.Group className="mb-3">
                          <Form.Label>
                            Address of the Sheet for accessing the Score(Score
                            in Column C, Email in Column B)
                          </Form.Label>
                          <Form.Control
                            type="text"
                            value={details.address}
                            onChange={(e) =>
                              handleChage("address", e.target.value)
                            }
                          />
                          {!details.address && (
                            <Form.Text>
                              Please enter a valid google document link
                            </Form.Text>
                          )}
                        </Form.Group>

                        <Form.Group className="mb-3">
                          <Form.Label>Link to Assessment</Form.Label>
                          <Form.Control
                            type="text"
                            value={details.linktoAssess}
                            onChange={(e) =>
                              handleChage("linktoAssess", e.target.value)
                            }
                          // isInvalid={!!error}
                          />
                          <Form.Text type="">
                            {!details.linktoAssess && error}
                          </Form.Text>
                        </Form.Group>


                        <Form.Group controlId="idealExp" className="mb-3">
                          <div className="mb-3 ">
                            <Form.Label>Ideal Experience</Form.Label>
                            <div
                              style={{
                                flex: 1,
                                border: "1px solid #ccc",
                                borderRadius: "5px",
                              }}
                            >
                              <Select
                                // isMulti
                                options={expOptions}
                                value={selectedExp}
                                onChange={handleExpChange}
                                classNamePrefix="select"
                                placeholder="Select ideal experience"
                              />

                            </div>
                          </div>
                        </Form.Group>

                        <div className="mb-3">
                          <label className="form-label">Ideal Education Level(s)</label>
                          <Select
                            isMulti
                            options={options}
                            value={selectedOptions}
                            onChange={handleChangemulti}
                            classNamePrefix="select"
                            placeholder="Select ideal Education Level"
                          />

                        </div>

                        <div className="mb-3">
                          <label className="form-label">Ideal Education Area(s)</label>
                          <Select
                            isMulti
                            options={optionsArealist}
                            value={selectedArea}
                            onChange={handleMultiArea}
                            classNamePrefix="select"
                            placeholder="Select ideal Education Area"
                          />

                        </div>

                        <div className="mb-3">
                          <label className="form-label">Ideal Industry(s)</label>
                          <Select
                            isMulti
                            options={optionsIndustry}
                            value={selectedIndustry}
                            onChange={handleMultiIndustry}
                            classNamePrefix="select"
                            placeholder="Select ideal Industry"
                          />

                        </div>

                        <div className="mb-3" >
                          <label className="form-label">Ideal Salary Range(s)</label>
                          <Select
                            isMulti
                            options={optionsSalary}
                            value={selectedSalary}
                            onChange={handleMultiSalary}
                            classNamePrefix="select"
                            placeholder="Select ideal Salary Range"
                          />

                        </div>





                        <Form.Group controlId="startDate" className="mb-3">
                          <Form.Label>Ideal Start Date</Form.Label>
                          <Form.Control
                            type="date"
                            value={details.startDate}
                            onChange={(e) =>
                              handleChage("startDate", e.target.value)
                            }
                            required
                          ></Form.Control>
                          <Form.Control.Feedback type="invalid">
                            Please Select the Ideal Start Date
                          </Form.Control.Feedback>
                        </Form.Group>
                      </div>
                    )}
                  </div>

                  <div className="col-6">
                    {details.reason === "Job Application" && (
                      <>
                        {
                          <table className="group-table table table-hover mb-5">
                            <thead>
                              <tr>
                                <th>Profile</th>
                                <th>Match</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Pioneer (1)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    required
                                    style={{ width: "65px" }}
                                    value={initialProfiles?.pioneer}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "pioneer",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  />
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Influencer (2)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    style={{ width: "65px" }}
                                    type="number"
                                    className="me-1"
                                    required
                                    value={initialProfiles?.influencer}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "influencer",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Team Player (3)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.teamPlayer}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "teamPlayer",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Logical Thinker (4)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.logicalThinker}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "logicalThinker",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Persuader (5)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.persuader}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "persuader",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Achiever (6)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.achiever}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "achiever",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Perfectionist (7)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.perfectionist}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "perfectionist",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Collaborator (8)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.collaborator}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "collaborator",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>

                              <tr>
                                <td>Accessor (9)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.assessor}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "assessor",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Implementor (10)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.implementor}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "implementor",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Motivator (11)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.motivator}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "motivator",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Leader (12)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.leader}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "leader",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Administrator (13)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.administrator}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "administrator",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>Mediator (14)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.mediator}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "mediator",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                              <tr>
                                <td>All Rounder (15)</td>
                                <td className="d-flex justify-content-center align-items-center">
                                  <Form.Control
                                    type="number"
                                    className="me-1"
                                    style={{ width: "65px" }}
                                    required
                                    value={initialProfiles.allRounder}
                                    onChange={(e) => {
                                      if (
                                        (Number(e.target.value) <= 100 &&
                                          Number(e.target.value >= 0)) ||
                                        e.target.value === ""
                                      ) {
                                        handleProfiles(
                                          "allRounder",
                                          Number(e.target.value)
                                        );
                                      }
                                    }}
                                  ></Form.Control>
                                  %
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        }
                        <Form.Group className="mb-3">
                          <Form.Label>Email Id to be used to send communications to candidate</Form.Label>
                          <Form.Select value={details.from} onChange={(e) => handleChage("from", e.target.value)}>
                            <option value="" selected disabled>Select Email</option>
                            {
                              emailList.filter(x => x.verified === true).map((email, index) => (
                                <option value={email.from_Email} key={index}>{email.from_Email}</option>
                              ))
                            }
                          </Form.Select>

                        </Form.Group>
                        <div>
                          <Form.Group
                            controlId="Primary match %"
                            className="mb-3 position-relative mt-3"
                          >
                            <div className="row justify-content-between mt-3">
                              <Form.Label>Job Access Group</Form.Label>
                              <div className="col">
                                <input
                                  type="email"
                                  className="form-control"
                                  isInvalid={valiteded && showEmails.length}
                                  placeholder="Job Access Group"
                                  value={enterEmail}
                                  onChange={(e) => setEnterEmail(e.target.value)}
                                />

                              </div>
                              <div className="col-2">
                                <button className="btnVldt" type="button" style={{ fontSize: "12px" }} onClick={handleAddEmail}>
                                  Add
                                </button>
                              </div>
                            </div>

                            {
                              <div className="col-5 position-absolute start-0 mt-3">
                                {showEmails.map((email, index) => (
                                  <span
                                    className="addbackgroundcolor px-2 py-1 rounded-5 me-3 text-nowrap"
                                    key={index}
                                  >
                                    {email?.email}
                                    <button
                                      type="button"
                                      className="btn-close"
                                      style={{
                                        width: "5px",
                                        height: "7px",
                                        marginLeft: "4px",
                                        opacity: "0.8",
                                        marginBottom: "-5px",
                                      }}
                                      onClick={() => removeEmail(index)}
                                    ></button>

                                  </span>
                                ))}
                              </div>
                            }
                          </Form.Group>
                        </div>

                      </>
                    )}
                  </div>
                  <div className={`d-flex justify-content-end`}>
                    <button className={`btnVldt ${isEdit ? "mt-55" : ""}`} style={{ fontSize: "12px" }} type="submit">
                      {isEdit ? "Update" : "Add"} Group
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default GroupList;
